import styled from 'styled-components';
import { Page } from '../../shared/components/page';
import { media } from '../../theme/media';

export const Container = styled(Page)``;

export const Content = styled.div`
  padding: 40px 24px 88px;
  ${media.tablet`
    padding: 80px 0 144px;
    max-width: 400px;
  `}
`;
